import formatValueCsv from './exportUtils'

const processRows = ({ dataSource, mainColumns, detailColumns, activeColumns, exportDetails }) => {
  const rows = []

  if (exportDetails) {
    dataSource.forEach((record) => {
      const mainRow = activeColumns.map((col, index) => {
        if (index < mainColumns.length) {
          return formatValueCsv(record[col.dataIndex], col, record)
        }
        return ''
      })
      rows.push(mainRow)

      const details = record.detalhes || []
      details.forEach((detail) => {
        const detailRow = activeColumns.map((col, index) => {
          if (index < mainColumns.length) return ''

          const detailColIndex = index - mainColumns.length
          const detailCol = detailColumns[detailColIndex]
          return formatValueCsv(detail[detailCol.dataIndex], detailCol, detail)
        })
        rows.push(detailRow)
      })
    })
  } else {
    dataSource.forEach((record) => {
      const row = mainColumns.map((col) => formatValueCsv(record[col.dataIndex], col, record))
      rows.push(row)
    })
  }

  return rows
}

export default processRows
